import { CartService } from '../services/CartService'
import { useCartStore } from '../store'
import { CartSupport } from '../support/CartSupport'

export const useCartModule = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(CartService)
    },
    get store() {
      return useCartStore()
    },
    get support() {
      return alt.get(CartSupport)
    },
  }
}
